import { createContext } from 'react';

export const SetLocaleContext = createContext<(locale: string) => void>(() => {});
